/**
 * map+join
 * @param fn
 * @param ms
 * @returns
 */
export const flatJoin = (separator: string, e: any[][]) =>
	e.map((e) => e.join(separator));
